var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 5l7 7-7 7"}));
}

ChevronRight.defaultProps = {"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
